"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _helper = require("@/mixins/helper/helper");

var _elementUi = require("element-ui");

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var FullscreenComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(FullscreenComponent, _Mixins);

  var _super = _createSuper(FullscreenComponent);

  function FullscreenComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, FullscreenComponent);
    _this = _super.apply(this, arguments);
    _this.isEnableOrderFullscreen = false;
    return _this;
  }

  (0, _createClass2.default)(FullscreenComponent, [{
    key: "$isFullscreen",
    get: function get() {
      return this.$store.getters['common/isFullscreen'];
    },
    set: function set(newVal) {
      this.$setFullscreen(newVal);
    }
  }, {
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    },
    set: function set(newVal) {
      this.$setOrderFullscreen(newVal);
    }
  }, {
    key: "$mainContainerHeight",
    get: function get() {
      return this.$store.getters['common/mainContainerHeight'];
    },
    set: function set(newVal) {
      this.$setMainContainerHeight(newVal);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('fullscreenchange', this.handleFullscreen);
      document.removeEventListener('MSFullscreenChange', this.handleFullscreen);
      document.removeEventListener('webkitfullscreenchange', this.handleFullscreen);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      document.addEventListener('fullscreenchange', this.handleFullscreen);
      document.addEventListener('MSFullscreenChange', this.handleFullscreen);
      document.addEventListener('webkitfullscreenchange', this.handleFullscreen);
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var isEnableOrderFullscreen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.isEnableOrderFullscreen = isEnableOrderFullscreen;

      if (this.$isFullscreen) {
        this.exitFullscreen();
      } else {
        this.reqFullscreen(document.documentElement);
      }
    }
  }, {
    key: "reqFullscreen",
    value: function reqFullscreen(el) {
      var bool = false;

      if (el.requestFullscreen) {
        el.requestFullscreen();
        bool = true;
      } else if (el.mozRequestFullScreen) {
        el.mozRequestFullScreen();
        bool = true;
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
        bool = true;
      } else if (el.msRequestFullscreen) {
        el.msRequestFullscreen();
        bool = true;
      } else {
        var message = {
          'title': this.$i18n.t('general.fullscreenNotAvail'),
          'duration': 5000
        };

        _elementUi.Notification.warning(message);
      }

      return bool;
    }
  }, {
    key: "exitFullscreen",
    value: function exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document['mozCancelFullScreen']) {
        document['mozCancelFullScreen']();
      } else if (document['webkitExitFullscreen']) {
        document['webkitExitFullscreen']();
      }
    }
  }, {
    key: "handleFullscreen",
    value: function handleFullscreen(e) {
      this.$isFullscreen = !this.helper.isUndefined(document.fullscreenElement || document['mozFullScreenElement'] || document['webkitFullscreenElement'] || document['msFullscreenElement'] || document['webkitIsFullScreen']);

      if (this.isEnableOrderFullscreen || !this.$isFullscreen && this.$isFullscreen !== this.$isOrderFullscreen) {
        this.$isOrderFullscreen = this.$isFullscreen;
        this.isEnableOrderFullscreen = false;
      }

      this.$mainContainerHeight = this.$isFullscreen ? screen.height : window.innerHeight - _variables.default['top-toolbar-height-no-unit'];
    }
  }]);
  return FullscreenComponent;
}((0, _vuePropertyDecorator.Mixins)(_helper.HelperMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_FULLSCREEN', {
  namespace: 'common'
})], FullscreenComponent.prototype, "$setFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_IS_ORDER_FULLSCREEN', {
  namespace: 'common'
})], FullscreenComponent.prototype, "$setOrderFullscreen", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Mutation)('SET_MAIN_CONTAINER_HEIGHT', {
  namespace: 'common'
})], FullscreenComponent.prototype, "$setMainContainerHeight", void 0);
FullscreenComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'FullscreenComponent'
})], FullscreenComponent);
var _default = FullscreenComponent;
exports.default = _default;